import { Component, computed, input } from '@angular/core';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';

@Component({
  selector: 'lib-data-table',
  standalone: true,
  imports: [LoadingSpinnerComponent],
  host: {
    '[class]': 'hostClasses()',
  },
  template: `
    <div class="msa-dt__header">
      <div>
        <h2 class="msa-dt__title">{{ title() }}</h2>
        @if (subtitle()) {
          <p class="msa-dt__subtitle">{{ subtitle() }}</p>
        }
      </div>
      <ng-content select="[header-actions]" />
    </div>
    <div class="msa-dt__body">
      @if (loading()) {
        <div class="msa-dt__loading-overlay" aria-live="polite" aria-label="Cargando datos">
          <lib-loading-spinner />
          <span class="msa-dt__loading-text">Cargando información...</span>
        </div>
      }
      <ng-content />
    </div>
  `,
  styles: [`
    /* ═══════════════════════════════════════════════
       MSA DataTable Compound
       ═══════════════════════════════════════════════
       Section wrapper with header and content area.
       All styles on :host / :host(.class).
       ═══════════════════════════════════════════════ */

    :host {
      display: block;
      overflow: hidden;
      border-radius: 12px;
      border: 1px solid #e5e7eb;
      background: #fff;
      font-family: inherit;
      box-sizing: border-box;
    }

    .msa-dt__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 12px 16px;
      border-bottom: 1px solid #e5e7eb;
      background: #f9fafb;
      flex-wrap: wrap;
    }

    .msa-dt__title {
      font-size: 14.5px;
      font-weight: 700;
      color: #0b1c33;
      margin: 0;
      line-height: 1.4;
    }

    .msa-dt__subtitle {
      font-size: 11.5px;
      color: #6b7280;
      margin: 2px 0 0;
      line-height: 1.4;
    }

    .msa-dt__body {
      position: relative;
      overflow-x: auto;
    }

    .msa-dt__loading-overlay {
      position: absolute;
      inset: 0;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      background: rgba(255, 255, 255, 0.74);
      backdrop-filter: blur(1px);
      pointer-events: all;
    }

    .msa-dt__loading-text {
      font-size: 12px;
      font-weight: 600;
      color: #475467;
    }

    ::ng-deep .msa-dt__body table {
      width: 100%;
      text-align: left;
      font-size: 12.5px;
    }
  `]
})
export class DataTableComponent {
  readonly title = input.required<string>();
  readonly subtitle = input<string>();
  readonly loading = input(false);

  readonly hostClasses = computed(() => ({
    'msa-dt': true,
  }));
}
